import { Col, Row } from "antd";
import React, { useEffect } from 'react';
import Icon, { ICON_NAME } from '../../../components/Icon';
import { callEventEditVessel, EditVesselProvider, useEditVessel } from "../../../contexts/EditVesselContext";
import { callEventPopup, openPopup2, POPUP_TYPE } from "../../../contexts/PopupContext";
import { selectTenant } from '../../../util/store/selectors';
import { useSelector } from '../../../util/store/store';
import { ACTION_TYPE, VESSEL_TYPE, vesselType, vesselTypes } from "../../../util/varibles/constants";
import { renderOpts } from '../../../util/varibles/global';
import { IVessel } from "../../../util/varibles/interface";
import AvailableTimeType from './_component/AvailableTimeType';
import CleaningTime from './_component/CleaningTime';
import CombineDensity from './_component/CombineDensity';
import CostInformation from './_component/CostInformation';
import Equipments from './_component/Equipments';
import JobTank from './_component/JobTank';
import ServiceCapabilities from './_component/ServiceCapabilities';
import Storages from './_component/Storages';
import VesselCapacity from './_component/VesselCapacity';
import VesselImage from './_component/VesselImage';
import VesselInput from './_component/VesselInput';
import VesselSubmit from './_component/VesselSubmit';
import VesselType from './_component/VesselType';
import styles from './style.module.scss';

const VesselForm: React.FC<{
    vessel?: IVessel
    editMode: ACTION_TYPE

    onSave(vessel: IVessel): void

    onClose(): void
}> = ({ editMode, vessel, onSave, onClose }) => {
    const [type, setStore] = useEditVessel(state => state.vessel?.type);
    const [formVessel] = useEditVessel(state => state.vessel);
    const tenant = useSelector(selectTenant);
    const { getMaterials } = callEventEditVessel()

    useEffect(() => {
        getMaterials()
    }, [getMaterials]);

    useEffect(() => {
        setStore({ vessel });
    }, [vessel, setStore]);

    return <div className={styles['select-vessel']}>
        {type === undefined ? <VesselType /> : <div>
            <Row gutter={[32, 16]}>
                <Col span={8}>
                    {editMode === ACTION_TYPE.CREATE && <div
                        className='flex gap-2 items-center cursor-pointer mb-3'
                        onClick={() => setStore(({ vessel: old }) => ({ vessel: { ...old, type: undefined } }))}
                    >
                        <Icon icon={ICON_NAME.ARROW_LEFT} style={{ height: '26px', width: '28px' }} />
                        <span className='text-[15px]'>Back</span>
                    </div>}
                    <VesselImage />
                </Col>
                <Col span={16}>
                    <div className="text-[18px] font-[600] mt-1  mb-3">{vesselType[type || '']?.name}</div>
                    <div className="text-[15px] font-[600] mb-2">Vessel info.</div>
                    <VesselInput id='name' />
                    {editMode === ACTION_TYPE.EDIT &&
                        <VesselInput id='type' options={renderOpts(vesselTypes)} />}
                    <VesselInput id='contact' />
                    <div className='grid grid-cols-2 gap-5'>
                        <VesselInput id='length' />
                        <VesselInput id='width' />
                    </div>
                    <VesselInput id='speed' />
                    {type !== VESSEL_TYPE.SERVICE &&
                        <VesselCapacity />}
                    {type !== VESSEL_TYPE.SERVICE && <div className='grid grid-cols-2 gap-x-5'>
                        {type === VESSEL_TYPE.WELL_BOAT ? <>
                            <VesselInput id='harvest_capacity' className='col-span-2' />
                            <VesselInput id='factory_discharge' />
                            <VesselInput id='waiting_unit_capacity' />
                        </> : <>
                            <VesselInput id='harvest_capacity' />
                            <VesselInput id='factory_discharge' />
                        </>}
                    </div>}
                    <CleaningTime />
                    <VesselInput id='mmsi' />
                    <AvailableTimeType />
                    <div className="mb-5 mt-5">
                        <div className="mb-5 text-[15px] font-[600]">“{tenant.name}” Cost info.</div>
                        <CostInformation
                            value={{
                                hourly_cost: formVessel?.hourly_cost,
                                cleaning_agent: formVessel?.cleaning_agent,
                                start_point: formVessel?.start_point,
                            }}
                            onChange={value => setStore(({ vessel: old }) => ({ vessel: { ...old, ...value } }))}
                        />
                    </div>
                    {type === VESSEL_TYPE.WELL_BOAT && <div className='text-[15px] font-[600] my-3'>
                        Add tank equipment and select the corresponding capabilities
                    </div>}
                    {type !== VESSEL_TYPE.SERVICE && <Storages />}
                    {type === VESSEL_TYPE.WELL_BOAT && <JobTank />}
                    {type !== VESSEL_TYPE.PROCESS_VESSEL && <Equipments vesselType={type} />}
                    {type !== VESSEL_TYPE.PROCESS_VESSEL && <ServiceCapabilities />}
                    {type === VESSEL_TYPE.WELL_BOAT && <CombineDensity />}
                </Col>
            </Row>
            <VesselSubmit editMode={editMode} onSave={onSave} onClose={onClose} />
        </div>}
    </div>;
};

interface IProps {
    editMode: ACTION_TYPE
    vessel?: IVessel

    onSave(vessel: IVessel): void
}

const PopupEditVessel: React.FC<IProps> = (props) => {
    const { editMode, vessel, onSave } = props;
    const { onClose } = callEventPopup();

    return <div className={styles['popup-edit-vessel']}    >
        <EditVesselProvider>
            <VesselForm vessel={vessel} editMode={editMode} onSave={onSave} onClose={onClose} />
        </EditVesselProvider>
    </div>;
};

export default PopupEditVessel;

export const openEditVessel = (props: IProps & { title?: string }) => {
    const { title = " ", ...args } = props;
    openPopup2(<PopupEditVessel {...args} />, { modalProps: { title, width: '100%' }, popupType: POPUP_TYPE.DRAWER })
}
